import React from 'react';
import { useParams } from 'react-router-dom';
import { TaskAuditPage } from './TaskAuditPage';

export const TaskAuditPageWrapper: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();

  return <TaskAuditPage key={taskId} />;
};

// Keep old export for backwards compatibility during migration
export const TaskDetailPageWrapper = TaskAuditPageWrapper;
